/* eslint-disable no-console */
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
// import { isProd } from './Utils';
import packageFile from '../../package.json';

const sentryDSN = 'https://0dd7e36c8c664731bbbafc7afa174f59@sentry-website.bharatpe.in/14';
const APP_NAME = `${packageFile.name}@${packageFile.version}`;

const isProd = (): boolean => true;

export const initSentry = (): void => {
	try {
		if (isProd()) {
			Sentry.init({
				dsn: sentryDSN,
				integrations: [new Integrations.BrowserTracing()],
				tracesSampleRate: 1.0,
				release: APP_NAME,
			});
		}
	} catch (e) {
		// eslint-disable-next-line no-undef
		console.error('SentryIntegrationError: ', e);
	}
};

/**
 * @function sendEvent
 * @param {object|string} event
 * @description manually send event/exception to Sentry
 */
export const sendEvent = (event: string | Error): void => {
	Sentry.captureException(event);
};
